export const templateCode = "280916";
export const searchFieldsList = "CustomColumn282sr,CustomColumn288sr,CustomColumn277sr,CustomColumn275sr,CustomColumn273sr,CustomColumn274sr,CustomColumn278sr,CustomColumn281sr,CustomColumn347sr,CustomColumn348sr,resolution,solution,CustomColumn349sr";
export const fixedValues = [
  {
    "key": "request_user",
    "value": "24261"
  },
  {
    "key": "problem_type",
    "value": "SGSO_Relato de Prevenção_Solicitação de Relato"
  },
  {
    "key": "status",
    "value": "1"
  },
  {
    "key": "assigned_group",
    "value": "113"
  },
  {
    "key": "responsibility",
    "value": "26026"
  }
];

export const fieldList = [
  {
    field: "CustomColumn282sr",
    type: "datetime-local",
    label: "Data da ocorrência",
    required: true,
    columns: "col-lg-4 col-md-6 col-sm-12"
  },
  {
    field: "CustomColumn288sr",
    type: "text",
    label: "Local do relato",
    required: true
  },
  {
    field: "CustomColumn277sr",
    type: "text",
    label: "Ponto de referência"
  },
  {
    field: "CustomColumn275sr",
    type: "text",
    label: "Empresas envolvidas",
    required: true
  },
  {
    field: "CustomColumn273sr",
    type: "text",
    label: "Autor do Relato"
  },
  {
    field: "CustomColumn274sr",
    type: "email",
    label: "E-mail do Autor do Relato"
  },
  {
    field: "CustomColumn278sr",
    type: "text",
    label: "Empresa do Autor do Relato"
  },
  {
    field: "CustomColumn281sr",
    type: "long-text",
    label: "Descrição do relato",
    required: true,
    options: null
  },
//   {
//     field: "CustomColumn347sr",
//     type: "select",
//     label: "Classificação em AVSEC",
//     required: true,
//     options: [
//       { value: "1", label: "Sim" },
//       { value: "2", label: "Não" }
//     ]
//   },
//   {
//     field: "CustomColumn348sr",
//     type: "select",
//     label: "Classificação do relato",
//     required: true,
//     options: [
//       { value: "1", label: "Vulnerabilidade" },
//       { value: "2", label: "Ameaça" },
//       { value: "3", label: "Ato de interferência ilícita" }
//     ]
//   },
  {
    field: "resolution",
    type: "long-text",
    label: "Resolução",
    search: true
  },
  {
    field: "solution",
    type: "long-text",
    label: "Solução",
    search: true
  },
  {
    field: "CustomColumn349sr",
    type: "text",
    label: "Data da Solução RELSEG",
    search: true
  }
];
